import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { countries, devConfig, profile } from 'config/config'; // Importing configuration data

/**
 * Class representing the FilterBalanceHistoryView.
 * @extends JetView
 */
export default class FilterBalanceHistoryView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row', // CSS class for styling
                    responsive: 'a1', // Responsive design identifier
                    cols: [
                        {
                            view: 'text', // Text input for User ID
                            name: 'UserId',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'), // Label with icon
                            hidden: !devConfig.getPermAction(
                                'filterByUser',
                                'Add', // Conditional visibility based on permissions
                            ),
                            css: 'prm-filterByUser', // CSS class for styling
                            labelPosition: 'top',
                            placeholder: _('ID Usuario'), // Placeholder text
                        },
                        {
                            view: 'datepicker', // Datepicker for selecting date
                            name: 'Date',
                            id: 'Date',
                            stringResult: false,
                            minWidth: 200,
                            type: 'month', // Month selection
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Creación'), // Label with icon
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: new Date(), // Default value set to current date
                            format: '%M %Y', // Date format
                        },
                        {
                            view: 'richselect', // Dropdown for country selection
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            minWidth: 200,
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Label with icon
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            on: {
                                onChange: function (data, obj) {
                                    // Event handler for change event
                                    var currentValue = this.getValue(); // Get current value
                                    if (screen.width > 600) {
                                        // Check screen width
                                        if (currentValue.length > 0) {
                                            $$('consultDesk').enable(); // Enable button if value exists
                                        } else {
                                            $$('consultDesk').disable(); // Disable button if no value
                                        }
                                    } else {
                                        if (currentValue.length > 0) {
                                            $$('consultDesk2').enable(); // Enable button for smaller screens
                                        } else {
                                            $$('consultDesk2').disable(); // Disable button for smaller screens
                                        }
                                    }
                                },
                            },
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Template for displaying country options
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            hidden:
                                devConfig.getCountryReport() ||
                                !devConfig.getPermAction(
                                    'filterByCountry',
                                    'Add', // Conditional visibility based on permissions
                                ),
                            css: 'prm-filterByCountry', // CSS class for styling
                        },
                        {
                            view: 'richselect', // Read-only dropdown for selected country
                            name: 'CountrySelect2',
                            minWidth: 200,
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Label with icon
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: profile.Settings.ReportCountry, // Default value from profile settings
                            readonly: true, // Read-only field
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Template for displaying country options
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            hidden:
                                !devConfig.getCountryReport() ||
                                !devConfig.getPermAction(
                                    'filterByCountry',
                                    'Add', // Conditional visibility based on permissions
                                ),
                            css: 'prm-filterByCountry', // CSS class for styling
                            css: 'country-hide', // Additional CSS class for hiding
                        },
                        {
                            view: 'richselect', // Dropdown for selecting own sales point
                            name: 'BetShopOwn',
                            minWidth: 200,
                            label: _('Punto de venta propio?'), // Label for own sales point
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                { id: 'S', value: _('Si') }, // Option for Yes
                                { id: 'N', value: _('No') }, // Option for No
                            ],
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row', // CSS class for styling
                    responsive: 'a1', // Responsive design identifier
                    cols: [
                        {
                            view: 'radio', // Radio buttons for selecting type
                            name: 'Type',
                            id: 'Type',
                            label: _('Tipo'), // Label for type selection
                            labelPosition: 'top',
                            minWidth: 200,
                            height:
                                screen.width < 500 || screen.height < 500
                                    ? 90 // Adjust height for small screens
                                    : 0,
                            value: 1, // Default value
                            options: [
                                { id: 1, value: _('Totales') }, // Option for Totals
                                { id: 0, value: _('Detallado') }, // Option for Detailed
                            ],
                        },
                        {
                            view: 'combo', // Dropdown for sorting options
                            name: 'Sort',
                            label: _('Ordenar por'), // Label for sorting
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                { id: '1', value: _('Calc. Desfase') }, // Sorting option
                                { id: '2', value: _('GGR. Deportivas') }, // Sorting option
                                { id: '3', value: _('GGR. Casino') }, // Sorting option
                                { id: '4', value: _('Fecha de Creación') }, // Sorting option
                            ],
                            value: '1', // Default sorting option
                        },
                        {
                            view: 'combo', // Dropdown for sorting direction
                            name: 'Dir',
                            label: _('Orden'), // Label for order
                            labelPosition: 'top',
                            minWidth: 200,
                            options: [
                                { id: '0', value: _('Ascendente') }, // Ascending option
                                { id: '1', value: _('Descendente') }, // Descending option
                            ],
                            value: '0', // Default sorting direction
                        },
                        { id: 'grav', gravity: 1 }, // Gravity for layout adjustment
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container', // CSS class for styling
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Button for clearing filters
                    value: _('Limpiar'), // Button label
                    width: 100,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                    },
                },
                {
                    view: 'button', // Button for consulting data
                    value: _('Consultar'), // Button label
                    hotkey: 'enter', // Hotkey for the button
                    type: 'form',
                    width: 110,
                    id: 'consultDesk', // ID for the button
                    disabled: true, // Initially disabled
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get filter data
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country based on profile
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        this.app.callEvent('balanceHistory:filter', [
                            filterdata, // Trigger filter event with data
                        ]);
                        $$('b5').collapse(); // Collapse the filter section
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button', // Button for clearing filters in popup
                    value: _('Limpiar'), // Button label
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues()); // Reset form values
                    },
                },
                {
                    view: 'button', // Button for consulting data in popup
                    id: 'consultDesk2', // ID for the button
                    disabled: true, // Initially disabled
                    value: _('Consultar'), // Button label
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get filter data
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country based on profile
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        this.app.callEvent('balanceHistory:filter', [
                            filterdata, // Trigger filter event with data
                        ]);
                        $$('filterPopup').hide(); // Hide the popup
                    },
                },
            ],
        };
        const accordion_section = {
            type: 'wide', // Type of accordion
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion component for filters
                    css: 'betShop', // CSS class for styling
                    collapsed: true, // Initially collapsed
                    type: 'clean', // Clean type for styling
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for filters
            scroll: 'xy', // Scroll in both directions
            body: {
                padding: 10,
                rows: [upper_section], // Upper section for filters
            },
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true, // Allow moving the window
            id: 'filterPopup', // ID for the popup
            fullscreen: true, // Fullscreen mode
            head: {
                view: 'toolbar', // Toolbar for the popup header
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Label for the header
                    {
                        view: 'icon', // Close icon for the popup
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on click
                        },
                    },
                ],
            },
            modal: true, // Modal window
            position: 'center', // Center position
            body: {
                view: 'form', // Form inside the popup
                id: 'myForm2', // ID for the form
                type: 'clean', // Clean type for styling
                rows: [accordion_section3, buttons2], // Accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
                },
            },
        });
        return {
            view: 'form', // Main form for the view
            id: 'myForm', // ID for the form
            type: 'clean', // Clean type for styling
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Show accordion section on larger screens
                    : { height: 1, width: 0 }, // Placeholder for smaller screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for Webix to be ready
            if (devConfig.getCountryReport()) {
                // Check if country report is enabled
                if (screen.width > 600) {
                    $$('consultDesk').enable(); // Enable button for larger screens
                } else {
                    $$('consultDesk2').enable(); // Enable button for smaller screens
                }
            }
        });
    }
}

// FILE DOCUMENTED
